import { Constants } from "appConstants";
import "./styles.scss";

type LabelProps = {
	children: React.ReactNode;
	isRequired: boolean;
	hideOptional?: boolean;
	className?: string;
};
export default function Label({
	children,
	isRequired,
	hideOptional,
	className
}: LabelProps) {
	return (
		<div className={`label ${className}`}>
			{children}
			{!isRequired && !hideOptional && (
				<span> ({Constants.strings.inputs.optionalField})</span>
			)}
		</div>
	);
}
